import * as Hangul from 'hangul-js'
import { Dialog } from '@headlessui/react'
import { EmojiSadIcon } from '@heroicons/react/outline'
import { MiniGrid } from '../mini-grid/MiniGrid'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  solution: string
}

export const LoseModal = ({
  isOpen,
  handleClose,
  guesses,
  solution
}: Props) => {
  return (
    <BaseModal title="실패!" isOpen={isOpen} handleClose={handleClose}>
      <div>
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
          <EmojiSadIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-lg leading-6 font-medium text-gray-900"
          >
            다시 도전해봐요.
          </Dialog.Title>
          <div className="mt-2">
            <MiniGrid guesses={guesses} />
            정답:&nbsp;
            <b id="solution_lose">{Hangul.assemble(solution.split(''))}</b>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          onClick={ () => document.location.reload() }
        >
          새로운 게임
        </button>
      </div>
    </BaseModal>
  )
}
